<template>
  <memberSkeketon :loading="skeletonLoading">
  </memberSkeketon>
</template>
<script>
import memberSkeketon from "../../components/memberSkeketon"
export default {
  name: '',
  components:{
    memberSkeketon
  },
  data () {
    return {
      skeletonLoading: true,
    }
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>

</style>